module.exports = __webpack_public_path__ + "static/img/honor1.38eec97.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/honor1.png
// module id = FK9R
// module chunks = 1